import script from "./EmployeesQuery.vue?vue&type=script&lang=js"
export * from "./EmployeesQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__